import * as React from 'react';
import './index.scss';

export function SellOut() {
    return (
        <div className="sell-out">
            <img alt="售完" className="sell-out__img" src={require('./goods-sell-out.png')} />
        </div>
    );
}
